import { isNodeList, isObjEmpty } from './common.js';



/**
*** 指定したオブジェクトに合わせてバリデーションする
*** @param {*} rules object
*** @param {*} values object
*** @param {*} addMethod object
*** @param {*} value object
*** @return Object
**/
export function isValid(target)
{
  // 引数のオブジェクトを再設定
  const rules     = Validations.rules,
        addMethod = Validations.addMethod,
        group     = Validations.group,
        name      = isNodeList(target) ? target[0].name : target.name,
        value     = Validations.value.value;



  // 標準メソッド
  const method = {
    required: function(value){
      return value !== undefined && value !== null && value.length > 0;
    },
    kana: function(value){
      return !value || /^([ぁ-んァ-ンヴー( |　)]+)$/.test(value);
    },
    zip: function(value){
      return !value || /^\d{7}$/.test(value);
    },
    tel: function(value){
      return !value || /^\d{10,11}$/.test(value);
    },
    mail: function(value){
      return !value || /^([a-zA-Z0-9])+([a-zA-Z0-9\._-])*@([a-zA-Z0-9_-])+([a-zA-Z0-9\._-]+)+$/.test(value);
    }
  };

  // 標準メソッドと追加メソッドをマージする
  const methods = Object.assign(method, addMethod);


  // rules に含まれているものだけバリデーションする
  if( isObjEmpty(rules) ){
    // rules が空の場合
    return true;
  } else {
    if( name in rules === false ) return true;
  };



  // Validation

  // 返り値用のオブジェクトを作成する
  const returnObj = { name: name, message: null, valid: null, required: null };

  // rules loop
  for( const rule in rules[name] ){

    // エラーメッセージを取得
    const message = rules[name][rule];

    // Method
    if( rule in methods ){

      // 要素の name（group or 単独）エラーメッセージがすでに入っていたら後の処理をスキップ
      if( returnObj.message ) continue;

      // required メソッドがあったかどうかを記憶しておく
      if( rule === 'required' ){
        returnObj.required = true;
      }
      else {
        // required 以外のメソッドは value が入力されたときだけバリデーションする
        //if( ! value ) continue;
      }


      // メソッドの結果 true
      if( methods[rule]( value, target ) ){
        // message クリア
        returnObj.message = null;
        returnObj.valid   = true;
      }
      // メソッドの結果 false
      else {
        // message 挿入
        returnObj.message = message;
        returnObj.valid   = false;
      }

    }

  } // rules loop end

  return returnObj;

}
